module.exports = __webpack_public_path__ + "img/icon_map_188_on_110.70185907.png";